import { Injectable } from '@angular/core';

import {
    IProcess,
    IProcessFull,
    IProcessTriggerTypeEmailSubscriptionUpdatedSettings,
    ProcessTriggerType
} from '@azavista/servicelib';
import { SharedService, TranslationKey } from '../shared';

@Injectable({
    providedIn: 'root'
})
export class GlobalProcessesService {
    constructor(private sharedSvc: SharedService) {
    }

    sapProcessTriggerValues(processes: IProcess[]): void {
        const triggerNameFieldName = this.sharedSvc.getProcessesTriggerNameFieldName();
        const triggerValueFieldName = this.sharedSvc.getProcessesTriggerValueFieldName();
        const processesWithTriggers = processes.filter(x => (x as IProcessFull).trigger);
        for (const process of processesWithTriggers) {
            const processFull: IProcessFull = process as IProcessFull;
            let values: string[];
            let translationKey: TranslationKey;
            if (processFull.trigger.type === ProcessTriggerType.entityUpdated) {
                values = processFull.trigger.triggers;
                translationKey = TranslationKey.entityUpdated;
            } else if (processFull.trigger.type === ProcessTriggerType.eventStatusChanged) {
                values = processFull.trigger.statuses;
                translationKey = TranslationKey.statusChangedTrigger;
            } else if (processFull.trigger.type === ProcessTriggerType.emailSubscriptionUpdated) {
                values = (processFull.trigger as IProcessTriggerTypeEmailSubscriptionUpdatedSettings).triggers;
                translationKey = TranslationKey.emailSubscriptionUpdateTrigger;
            }
            processFull[triggerValueFieldName] = values?.join(', ');
            processFull[triggerNameFieldName] = translationKey ? this.sharedSvc.translate(translationKey) : '';
        }
    }
}
